import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import DashboardLayout from "@/components/DashboardLayout";
import NewRequest from "@/pages/NewRequest";
import MyRequests from "@/pages/MyRequests";
import AdminRequests from "@/pages/AdminRequests";
import Vehicles from "@/pages/Vehicles";
import FuelCards from "@/pages/FuelCards";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Stats from "@/pages/Stats";
import StoricoRichieste from "@/pages/StoricoRichieste";
import Anagrafiche from "@/pages/Anagrafiche";
import Profile from "@/pages/Profile";
import Home from "@/pages/Home";
import NuovoRapportino from "@/pages/NuovoRapportino";
import MieiRapportini from "@/pages/MieiRapportini";
import Rapportini from "@/pages/Rapportini";
import RapportiniDashboard from "@/pages/RapportiniDashboard";
import Commesse from "@/pages/Commesse";
import Listini from "@/pages/Listini";
import ListinoEdit from "@/pages/ListinoEdit";
import UnitaMisura from "@/pages/UnitaMisura";
import TipiOre from "@/pages/TipiOre";
import ActivityTypes from "@/pages/ActivityTypes";
import Logs from "@/pages/Logs";
import Consumi from "@/pages/Consumi";
import CheckIn from "@/pages/CheckIn";
import Checkins from "@/pages/Checkins";
import Attrezzature from "@/pages/Attrezzature";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#002FA7]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route index element={<Home />} />
        <Route path="carburante" element={<Stats />} />
        <Route path="profilo" element={<Profile />} />
        <Route path="nuovo-rapportino" element={<NuovoRapportino />} />
        <Route path="rapportino/:id" element={<NuovoRapportino />} />
        <Route path="miei-rapportini" element={<MieiRapportini />} />
        <Route path="rapportini" element={<Protected roles={["approvatore", "admin"]}><Rapportini /></Protected>} />
        <Route path="rapportini-dashboard" element={<RapportiniDashboard />} />
        <Route path="commesse" element={<Protected roles={["admin"]}><Commesse /></Protected>} />
        <Route path="listini" element={<Protected roles={["admin"]}><Listini /></Protected>} />
        <Route path="listini/nuovo" element={<Protected roles={["admin"]}><ListinoEdit /></Protected>} />
        <Route path="listini/:id" element={<Protected roles={["admin"]}><ListinoEdit /></Protected>} />
        <Route path="unita-misura" element={<Protected roles={["admin"]}><UnitaMisura /></Protected>} />
        <Route path="tipi-ore" element={<Protected roles={["admin"]}><TipiOre /></Protected>} />
        <Route path="tipi-attivita" element={<Protected roles={["admin"]}><ActivityTypes /></Protected>} />
        <Route path="log" element={<Protected roles={["admin"]}><Logs /></Protected>} />
        <Route path="check-in" element={<CheckIn />} />
        <Route path="check-in-list" element={<Protected roles={["approvatore", "admin"]}><Checkins /></Protected>} />
        <Route path="attrezzature" element={<Protected roles={["admin"]}><Attrezzature /></Protected>} />
        <Route path="nuova-richiesta" element={<NewRequest />} />
        <Route path="le-mie-richieste" element={<MyRequests />} />
        <Route
          path="richieste"
          element={
            <Protected roles={["approvatore", "admin"]}>
              <AdminRequests />
            </Protected>
          }
        />
        <Route
          path="storico"
          element={
            <Protected roles={["approvatore", "admin"]}>
              <StoricoRichieste />
            </Protected>
          }
        />
        <Route
          path="consumi"
          element={
            <Protected roles={["approvatore", "admin"]}>
              <Consumi />
            </Protected>
          }
        />
        <Route
          path="anagrafiche"
          element={
            <Protected roles={["admin"]}>
              <Anagrafiche />
            </Protected>
          }
        />
        <Route
          path="mezzi"
          element={
            <Protected roles={["admin"]}>
              <Vehicles />
            </Protected>
          }
        />
        <Route
          path="carte"
          element={
            <Protected roles={["admin"]}>
              <FuelCards />
            </Protected>
          }
        />
        <Route
          path="utenti"
          element={
            <Protected roles={["admin"]}>
              <Users />
            </Protected>
          }
        />
        <Route
          path="impostazioni"
          element={
            <Protected roles={["admin"]}>
              <Settings />
            </Protected>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
